import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_WEBTOON_BY_PROGRAM_ID } from "../../../../quries/webtoon";
import WebtoonThumbBox from "../../../../components/MainComponent/WebToonComponent/WebtoonThumbBox";

const useStyles = makeStyles((theme) =>
  createStyles({
    aspectRatioBox: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      // borderRadius: 24,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      textAlign: "center",
      fontSize: 20,
      color: "white",
      background: "no-repeat center center",
      backgroundImage: "url(/images/history/3.png)",
      backgroundSize: "100%",
      borderTopLeftRadius: 40,
      borderTopRightRadius: 40,
    },

    thumbTitle: {
      fontSize: 20,
      fontFamily: "GmarketSansBold",
      fontWeight: 700,
      paddingLeft: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },

    thumbContainer: {
      padding: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 0,
      },
    },

    topContainer: {
      padding: 32,
      [theme.breakpoints.down("xs")]: {
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 0,
      },
    },
  })
);

interface WebtoonInGalleryProps {
  programId: any;
}

function WebtoonInGallery({ programId }: WebtoonInGalleryProps) {
  const classes = useStyles();
  const [webtoonArr, setWebtoonArr] = useState<any>(null);

  const { data, loading, error } = useQuery(GET_WEBTOON_BY_PROGRAM_ID, {
    variables: {
      where: {
        web_toons_program: {
          id: programId,
        },
      },
      sort: "created_at:DESC",
    },
  });

  useEffect(() => {
    if (data && data.webToons) {
  
      setWebtoonArr(data.webToons);
    }
    return () => {};
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.webToons) {
    console.log(error);
  }

  if (webtoonArr) {
    return (
      <Grid xs={12} item container>
        {webtoonArr.map((element: any, index: any) => {
          return (
            <WebtoonThumbBox
              key={`webtoon-birdeye-${element.title}-${index}`}
              webtoon={element}
            />
          );
        })}
      </Grid>
    );
  } else {
    return <div></div>;
  }
}
export default WebtoonInGallery;
